import { render, staticRenderFns } from "./AreaViewSidebar.vue?vue&type=template&id=28cec6b0&scoped=true&"
import script from "./AreaViewSidebar.vue?vue&type=script&lang=js&"
export * from "./AreaViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AreaViewSidebar.vue?vue&type=style&index=0&id=28cec6b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cec6b0",
  null
  
)

export default component.exports